export default "__VITE_ASSET__Y1m8ck$7__"